import React from 'react';
import ProjectCustomerGroupWise from '../../../components/Dashboard/ProjectCustomerGroupWise';
import { FileText } from 'lucide-react';

const ProjectCustomerGroupWiseReport = () => {
        return (
                <div className="pb-14 ">
                        <div className="flex mx-3 p-6 gap-3 ">
                                        <div>
                                            <div className="text-[24px] font-semibold">
                                                All Projects Customer Group Wise
                                            </div>
                                            <div className="text-gray-500 text-sm">
                                                * All figures are in Rupees (in Crores)
                                            </div>
                                        </div>
                                    </div>
                        <div className="px-5">
                                <ProjectCustomerGroupWise />
                        </div>
                </div>
        );
};

export default ProjectCustomerGroupWiseReport;
